"use strict";
export var CommonErrorType;
(function (CommonErrorType) {
    CommonErrorType["BadRequest"] = "BadRequest";
    CommonErrorType["UnauthorizedAccess"] = "UnauthorizedAccess";
    CommonErrorType["AnonymousCurrentUser"] = "AnonymousCurrentUser";
    CommonErrorType["ObjectNotFound"] = "ObjectNotFound";
    CommonErrorType["EndpointNotFound"] = "EndpointNotFound";
    CommonErrorType["CriticalStorageFailure"] = "CriticalStorageFailure";
    CommonErrorType["ExternalServiceError"] = "ExternalServiceError";
    CommonErrorType["SignupInfoNotValid"] = "SignupInfoNotValid";
    CommonErrorType["DefaultPaymentProfileNotValidForRequest"] = "DefaultPaymentProfileNotValidForRequest";
    CommonErrorType["EndpointNotImplemented"] = "EndpointNotImplemented";
    CommonErrorType["UnauthorizedDatabaseInsertOrUpdate"] = "UnauthorizedDatabaseInsertOrUpdate";
    CommonErrorType["UserAlreadyExists"] = "UserAlreadyExists";
    CommonErrorType["GiveTransactionError"] = "GiveTransactionError";
    CommonErrorType["UnknownInternalServiceException"] = "UnknownInternalServiceException";
})(CommonErrorType || (CommonErrorType = {}));
export const CommonErrorStandards = {
    [CommonErrorType.BadRequest]: {
        code: 400,
        message: "Malformed request",
    },
    [CommonErrorType.UnauthorizedAccess]: {
        code: 401,
        message: "Unauthorized access",
    },
    [CommonErrorType.AnonymousCurrentUser]: {
        code: 401,
        message: "Unauthorized access",
    },
    [CommonErrorType.ObjectNotFound]: {
        code: 404,
        message: "Object not found",
    },
    [CommonErrorType.EndpointNotFound]: {
        code: 404,
        message: "Endpoint not found",
    },
    [CommonErrorType.CriticalStorageFailure]: {
        code: 502,
        message: "External service error",
    },
    [CommonErrorType.ExternalServiceError]: {
        code: 503,
        message: "External service error",
    },
    [CommonErrorType.UnauthorizedDatabaseInsertOrUpdate]: {
        code: 504,
        message: "The insert or update to the service database was not allowed"
    },
    [CommonErrorType.UserAlreadyExists]: {
        code: 505,
        message: "This user already exists in the service database"
    },
    [CommonErrorType.SignupInfoNotValid]: {
        code: 506,
        message: "The signup information provided could not be verified"
    },
    [CommonErrorType.DefaultPaymentProfileNotValidForRequest]: {
        code: 507,
        message: "The default payment profile is not valid to continue with the request"
    },
    [CommonErrorType.GiveTransactionError]: {
        code: 507,
        message: "We were unable to complete the requested giving transaction"
    },
    [CommonErrorType.EndpointNotImplemented]: {
        code: 515,
        message: "Endpoint not implemented",
    },
    [CommonErrorType.UnknownInternalServiceException]: {
        code: 516,
        message: "Unrecognized exception thrown by an internal service",
    },
};
function makeErrorStandardsArray() {
    const esArray = new Array();
    for (const prop in CommonErrorStandards) {
        esArray.push({
            code: CommonErrorStandards[prop].code,
            type: prop,
            message: CommonErrorStandards[prop].message,
        });
    }
    return (esArray);
}
export const CommonErrorStandardsByCode = new Map(makeErrorStandardsArray().map((es) => [es.code, es]));
